var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWizardTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#5bc2a8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.93,49.31A.5.5,0,0,1,1.48,49a.49.49,0,0,1,0-.52L17.6,25.65a1.52,1.52,0,0,0,0-1.74L1.54,1.49A.49.49,0,0,1,1.5,1,.5.5,0,0,1,2,.69H128.62a.49.49,0,0,1,.4.21l17.09,23.59a.48.48,0,0,1,0,.58L129,49.09a.48.48,0,0,1-.41.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.62,1.19h0l17.09,23.59-17.1,24H1.93L18,25.93a2,2,0,0,0,0-2.31L2,1.19H128.62m0-1H2a1,1,0,0,0-.82,1.59L17.18,24.2a1,1,0,0,1,0,1.16L1.11,48.23a1,1,0,0,0,.82,1.58H128.61a1,1,0,0,0,.82-.42l17.09-24a1,1,0,0,0,0-1.16L129.43.61a1,1,0,0,0-.81-.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizardTab);
export default __webpack_public_path__ + "static/media/wizardTab.4ef51be9d00eee4d24f122f422b9ed02.svg";
export { ForwardRef as ReactComponent };